var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container asset-po-page" },
    [
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "120px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "PO单号" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入PO单号" },
                              model: {
                                value: _vm.searchForm.opTicketid,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "opTicketid", $$v)
                                },
                                expression: "searchForm.opTicketid"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "DCOPS单号" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入DCOPS单号" },
                              model: {
                                value: _vm.searchForm.dcops_ticket_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchForm,
                                    "dcops_ticket_id",
                                    $$v
                                  )
                                },
                                expression: "searchForm.dcops_ticket_id"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "机房名称" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入机房名称" },
                              model: {
                                value: _vm.searchForm.idc_name,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "idc_name", $$v)
                                },
                                expression: "searchForm.idc_name"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "任务名称" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入任务名称" },
                              model: {
                                value: _vm.searchForm.task_name,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "task_name", $$v)
                                },
                                expression: "searchForm.task_name"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "是否超时" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请选择", clearable: "" },
                                model: {
                                  value: _vm.searchForm.is_expired,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "is_expired", $$v)
                                  },
                                  expression: "searchForm.is_expired"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "未超时", value: 0 }
                                }),
                                _c("el-option", {
                                  attrs: { label: "已超时", value: 1 }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("搜索")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置")
                          ]),
                          _c(
                            "el-button",
                            { on: { click: _vm.openColumnsDialog } },
                            [_vm._v("列设置")]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "po-detail-table",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" }
        },
        _vm._l(_vm.visibleColumns, function(column) {
          return _c("el-table-column", {
            key: column.prop,
            attrs: {
              prop: column.prop,
              label: column.label,
              width: column.width,
              "min-width": column.minWidth || 120,
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      column.prop === "assets_data"
                        ? _c(
                            "span",
                            [
                              _c("json-view-dialog", {
                                attrs: {
                                  content: scope.row[column.prop],
                                  title: column.label,
                                  width: "85%",
                                  "max-height": 560
                                }
                              })
                            ],
                            1
                          )
                        : column.prop === "is_expired"
                        ? _c(
                            "span",
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type:
                                      scope.row[column.prop] === 1
                                        ? "danger"
                                        : scope.row[column.prop] === 0
                                        ? "success"
                                        : "info",
                                    size: "small"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        scope.row[column.prop] === 1
                                          ? "已超时"
                                          : scope.row[column.prop] === 0
                                          ? "未超时"
                                          : "-"
                                      ) +
                                      "\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : column.prop === "expire_time" ||
                          column.prop === "finished_time"
                        ? _c("span", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  scope.row[column.prop]
                                    ? _vm
                                        .$moment(scope.row[column.prop])
                                        .format("YYYY-MM-DD HH:mm:ss")
                                    : "-"
                                ) +
                                "\n        "
                            )
                          ])
                        : _c("span", [
                            _vm._v(_vm._s(scope.row[column.prop] || "-"))
                          ])
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
        }),
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
              total: _vm.total,
              layout: "total, sizes, prev, pager, next, jumper"
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "列设置",
            visible: _vm.showColumnsDialog,
            width: "400px",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.showColumnsDialog = $event
            }
          }
        },
        [
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.selectedColumns,
                callback: function($$v) {
                  _vm.selectedColumns = $$v
                },
                expression: "selectedColumns"
              }
            },
            _vm._l(_vm.columns, function(column) {
              return _c(
                "div",
                { key: column.prop, staticStyle: { "margin-bottom": "10px" } },
                [
                  _c("el-checkbox", { attrs: { label: column.prop } }, [
                    _vm._v(_vm._s(column.label))
                  ])
                ],
                1
              )
            }),
            0
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.showColumnsDialog = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c("el-button", { on: { click: _vm.selectAllColumns } }, [
                _vm._v("全选")
              ]),
              _c("el-button", { on: { click: _vm.restoreDefaultColumns } }, [
                _vm._v("恢复默认")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveColumnsDialog }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }